import { Component, Input } from '@angular/core';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';

@Component({
    selector: 'app-product-detail-display-common-features',
    templateUrl: './product-detail-display-common-features.component.html',
    styleUrls: [
        './product-detail-display-common-features.component.css'
    ],
    standalone: false
})
export class ProductDetailDisplayCommonFeaturesComponent {
    @Input()
    set commonFeatures(productCommonFeatures: ProductCommonFeatureInterface[]) {
        const commonFeaturesByName = new Map<
            string,
            {
                featureName: string;
                entryNames: string[];
                position: number;
            }
        >();
        for (const productCommonFeature of productCommonFeatures) {
            if (!productCommonFeature.feature.showDetailPage) {
                continue;
            }
            if (!commonFeaturesByName.has(productCommonFeature.feature.name)) {
                commonFeaturesByName.set(productCommonFeature.feature.name, {
                    featureName: productCommonFeature.feature.name,
                    entryNames: [],
                    position: productCommonFeature.feature.position
                });
            }
            commonFeaturesByName
                .get(productCommonFeature.feature.name)
                .entryNames.push(productCommonFeature.entry.name);
        }
        for (const productFeatureValues of commonFeaturesByName.values()) {
            productFeatureValues.entryNames.sort((a, b) =>
                a.toLowerCase().localeCompare(b.toLowerCase())
            );
        }
        this.productCommonFeatures = Array.from(
            commonFeaturesByName.values()
        ).sort((a, b) => a.position - b.position);
    }

    productCommonFeatures: {
        featureName: string;
        entryNames: string[];
        position: number;
    }[];

}
